import PropTypes from 'prop-types';
import Icon from "../Icon/Icon";
import cn from "../../../utils/cn";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const InfoPanel = _ref => {
  let {
    className = '',
    message,
    id = '',
    color = 'text-blue',
    size = 'sm',
    showIcon = true
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: cn('flex items-start rounded', className),
    id: id,
    children: [showIcon && /*#__PURE__*/_jsx(Icon, {
      id: `${id}_icon`,
      className: "flex-initial mt-px",
      icon: "ExclamationCircle",
      color: color
    }), /*#__PURE__*/_jsx("p", {
      className: `px-2.5 text-${size} flex-1 text-${color}`,
      id: `${id}_text`,
      children: message
    })]
  });
};
InfoPanel.propTypes = {
  /** Class name */
  className: PropTypes.string,
  /** Icon and text color */
  color: PropTypes.string,
  /** id for reference */
  id: PropTypes.string,
  /** Panel message text */
  message: PropTypes.string.isRequired,
  /** Font size */
  size: PropTypes.oneOf(['xs', 'sm'])
};
export default InfoPanel;
//# sourceMappingURL=InfoPanel.js.map